<woa-modal-page-layout [showCloseButton]="false" [showCancelLink]="true"
                       [showContent]="!!searchText()" [showFooter]="false">
    <div class="menu-search-entry" slot="header-left">
        <woa-icon class="menu-search-entry-icon" [name]="'search'"></woa-icon>
        <div class="menu-search-entry-field">
            <input class="menu-search-entry-field-input" type="text" [(ngModel)]="searchText" #input>
            @if (!searchText()) {
                <div class="menu-search-entry-field-placeholder">
                    {{ 'woa.message.menu-search.placeholder' | translate }}
                </div>
            }
        </div>
    </div>
    @for (itemInCategory of itemsInCategories(); track itemInCategory; let i = $index) {
        <woa-menu-item-panel class="menu-search-item" id="item-{{i}}"
                             [fromSearch]="true"
                             [category]="itemInCategory.category"
                             [menuItem]="itemInCategory.menuItem"
                             [showCategoryPath]="true"></woa-menu-item-panel>
    }
    @if (!itemsInCategories().length) {
        <woa-content-message [level]="MessageLevel.INFO"
                             [text]="'woa.message.menu-search.noItems'"></woa-content-message>
    }
</woa-modal-page-layout>
